/**
 * Applies a plain-number percentage markup on top of an amount (`10` = +10%). Shared by
 * `computeAiCost` (the billed-charge calculation) and the Model Rates admin page's
 * display-only effective-price preview — both need the same `amount × (1 + markupPct / 100)`
 * multiplier. Pure function — no I/O, no DB, no DI, no rounding (callers round to their own
 * precision).
 */
export function applyMarkupPct(amount: number, markupPct: number): number {
  return amount * (1 + markupPct / 100)
}
